/* eslint-disable @typescript-eslint/no-explicit-any */
import api from "./api/api.catalogos";
import { CatalogResponse, ApiError } from "./types/catalogos.types";
import { CAT014Response, CAT014Error } from "./types/CAT-014.types";
import { CAT012Response, CAT012Error } from "./types/CAT-012.types";
import { CAT013Response, CAT013Error } from "./types/CAT-013.types";
import { CAT015Response, CAT015Error } from "./types/CAT-015.types";
import { CAT016Response, CAT016Error } from "./types/CAT-016.types";
import { CAT017Response, CAT017Error } from "./types/CAT-017.types";
import { CAT019Response, CAT019Error } from "./types/CAT-019.types";
import { CAT022Response, CAT022Error } from "./types/CAT-022.types";

export const getCatalogs = async (): Promise<CatalogResponse> => {
  try {
    const response = await api.get<CatalogResponse>("/catalog");
    return response.data;
  } catch (error: any) {
    const apiError: ApiError = {
      message:
        error.response?.data?.message ||
        error.message ||
        "Error al obtener catálogos",
      status: error.response?.status,
    };
    throw apiError;
  }
};

// Función específica para obtener las unidades de medida (CAT-014)
export const getUnidadesMedida = async (): Promise<CAT014Response> => {
  try {
    const response = await api.get<CAT014Response>("/catalog/CAT-014");
    return response.data;
  } catch (error: any) {
    const apiError: CAT014Error = {
      message:
        error.response?.data?.message ||
        error.message ||
        "Error al obtener unidades de medida",
      status: error.response?.status,
    };
    throw apiError;
  }
};

// Función específica para obtener los departamentos (CAT-012)
export const getDepartamentos = async (): Promise<CAT012Response> => {
  try {
    const response = await api.get<CAT012Response>("/catalog/CAT-012");
    return response.data;
  } catch (error: any) {
    const apiError: CAT012Error = {
      message:
        error.response?.data?.message ||
        error.message ||
        "Error al obtener departamentos",
      status: error.response?.status,
    };
    throw apiError;
  }
};

// Función específica para obtener los municipios (CAT-013)
export const getMunicipios = async (): Promise<CAT013Response> => {
  try {
    const response = await api.get<CAT013Response>("/catalog/CAT-013");
    return response.data;
  } catch (error: any) {
    const apiError: CAT013Error = {
      message:
        error.response?.data?.message ||
        error.message ||
        "Error al obtener municipios",
      status: error.response?.status,
    };
    throw apiError;
  }
};

// Función específica para obtener los tributos (CAT-015)
export const getTributos = async (): Promise<CAT015Response> => {
  try {
    const response = await api.get<CAT015Response>("/catalog/CAT-015");
    return response.data;
  } catch (error: any) {
    const apiError: CAT015Error = {
      message:
        error.response?.data?.message ||
        error.message ||
        "Error al obtener tributos",
      status: error.response?.status,
    };
    throw apiError;
  }
};

// Función específica para obtener las condiciones de operación (CAT-016)
export const getCondicionesOperacion = async (): Promise<CAT016Response> => {
  try {
    const response = await api.get<CAT016Response>("/catalog/CAT-016");
    return response.data;
  } catch (error: any) {
    const apiError: CAT016Error = {
      message:
        error.response?.data?.message ||
        error.message ||
        "Error al obtener condiciones de operación",
      status: error.response?.status,
    };
    throw apiError;
  }
};

// Función específica para obtener las formas de pago (CAT-017)
export const getFormasPago = async (): Promise<CAT017Response> => {
  try {
    const response = await api.get<CAT017Response>("/catalog/CAT-017");
    return response.data;
  } catch (error: any) {
    const apiError: CAT017Error = {
      message:
        error.response?.data?.message ||
        error.message ||
        "Error al obtener formas de pago",
      status: error.response?.status,
    };
    throw apiError;
  }
};

// Función específica para obtener los códigos de actividad económica (CAT-019)
export const getCodigosActividadEconomica = async (): Promise<CAT019Response> => {
  try {
    const response = await api.get<CAT019Response>("/catalog/CAT-019");
    return response.data;
  } catch (error: any) {
    const apiError: CAT019Error = {
      message:
        error.response?.data?.message ||
        error.message ||
        "Error al obtener códigos de actividad económica",
      status: error.response?.status,
    };
    throw apiError;
  }
};

// Función específica para obtener los tipos de documento de receptor (CAT-022)
export const getTiposDocumentoReceptor = async (): Promise<CAT022Response> => {
  try {
    const response = await api.get<CAT022Response>("/catalog/CAT-022");
    return response.data;
  } catch (error: any) {
    const apiError: CAT022Error = {
      message:
        error.response?.data?.message ||
        error.message ||
        "Error al obtener tipos de documento de receptor",
      status: error.response?.status,
    };
    throw apiError;
  }
};
